export type InquireType = {
    inquire_type_id: string;
    inquire_type_name: string;
};

export type Reasons = {
    reason_id: string;
    reason_name: string;
};

// /api/master/inquire response
export type MasterInquireApiResponse = {
    inquire_type: Array<InquireType>;
    reasons: Array<Reasons>;
};

// 初期値
export const MASTER_INQUIRE_INIT: MasterInquireApiResponse = {
    inquire_type: [],
    reasons: [],
};

// API ERROR
export const MASTER_INQUIRE_API_ERRORS = {
    REQUEST_ERROR_9002: 'REQUEST_ERROR(9002)',
    REQUEST_ERROR_9002_STATUS_CODE: 'REQUEST_ERROR(9002)_%1',
};
